import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import Button from '../Common/Button';
import Card from '../Common/Card';
import './AuthSection.css';

const AuthSection: React.FC = () => {
  const { user, loading, error, signIn, signOut } = useAuth();

  if (loading) {
    return (
      <div className="auth-section">
        <Card>
          <div className="auth-section__loading">
            Loading...
          </div>
        </Card>
      </div>
    );
  }

  if (user) {
    return (
      <div className="auth-section">
        <Card>
          <div className="auth-section__user">
            <div className="auth-section__info">
              <h3>
                {user.displayName || 'Signed In'}
              </h3>
              {user.email && (
                <p className="auth-section__email">{user.email}</p>
              )}
            </div>
            <Button
              variant="SECONDARY"
              size="SMALL"
              onClick={signOut}
            >
              Sign Out
            </Button>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="auth-section">
      <Card title="Sign In to Continue">
        <div className="auth-section__buttons">
          <Button
            variant="PRIMARY"
            onClick={signIn}
            disabled={loading}
          >
            Sign in with Google
          </Button>
        </div>
        {error && (
          <div className="auth-section__error">
            {error}
          </div>
        )}
      </Card>
    </div>
  );
};

export default AuthSection;